import { useCallback } from 'react';
import { updateLocale, useLanguageChange } from '@repo-level/core-front';
import { useTranslation } from 'react-i18next';

import { Select } from 'components/form/Select';
import { optionsLanguages } from './helpers';
import { Locale } from 'languages';

import { ScLanguageSwitcher } from './styled';

type AvailableLocales = Exclude<
  Locale,
  Locale.SLOVENIAN | Locale.NORWEGIAN | Locale.FRENCH_SWITZERLAND
>;

const LocaleRecord: Record<AvailableLocales, Locale> = {
  [Locale.ENGLISH]: Locale.ENGLISH,
  [Locale.ENGLISH_NEW_ZEALAND]: Locale.ENGLISH_NEW_ZEALAND,
  [Locale.ENGLISH_AUSTRALIA]: Locale.ENGLISH_AUSTRALIA,
  [Locale.ENGLISH_CANADA]: Locale.ENGLISH_CANADA,
  [Locale.FRENCH_CANADA]: Locale.FRENCH_CANADA,
  [Locale.FRENCH]: Locale.FRENCH_SWITZERLAND,
  [Locale.GERMAN]: Locale.GERMAN,
  [Locale.IRISH]: Locale.IRISH,
};

export const LanguageSwitcher = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [handleChangeLanguage] = useLanguageChange();

  const changeLanguage = useCallback(
    (lng: AvailableLocales) => {
      handleChangeLanguage(lng);
      try {
        updateLocale({ locale: LocaleRecord[lng] });
      } catch {
        console.error('Error updating locale');
      }
    },
    [handleChangeLanguage]
  );

  return (
    <ScLanguageSwitcher>
      <Select
        key={language}
        initialValue={language}
        up
        lightColoredDropMode
        withBorderArrow
        field="language"
        placeholder={t('glossary:region')}
        options={optionsLanguages}
        lightBg
        onSelect={(lang: any) => {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 200);
          void changeLanguage(lang);
        }}
        maxHeight={268}
      />
    </ScLanguageSwitcher>
  );
};
